<script setup lang="ts">
const props = defineProps<{
  product: SingleProduct
}>()

const gradeOptions = computed<Options<string, { grades?: GradeCode[] }>>(() => {
  if (props.product.template === 'grunnskole') {
    return GRUNNSKOLE_GRADE_OPTIONS
  }

  switch (props.product.levelFilter) {
    case 'alle':
      return ALL_GRADE_OPTIONS
    case 'ungdomsskole':
      return UNGDOMSSKOLE_GRADE_OPTIONS
    case 'vgs':
    default:
      return VGS_GRADE_OPTIONS
  }
})

const showFilter = computed(() => props.product.variants.length >= 4)
</script>

<template>
  <article class="bg-white text-(--color)">
    <header
      class="w-full"
      :class="[
        product?.type === 'single-product' && product.template === 'standard2'
          ? 'bg-(--theme-50)'
          : 'bg-(--background)',
      ]"
    >
      <slot name="hero" />
    </header>

    <UiGraphicsCurtain
      v-if="product.template === 'standard2'"
      class="absolute"
      :style="{ '--curtain': 'var(--theme-50)' }"
    />

    <UContainer v-if="showFilter">
      <UiProductsFilter
        :product="product"
        :filter-key="product.levelFilter === 'alle' ? 'level' : 'grade'"
        :grade-options="gradeOptions"
      />
    </UContainer>

    <IconsArrowsDownShort class="mx-auto -mt-8 w-full translate-y-4 fill-(--theme-pop)" />

    <UiProductsVariantsAccordion
      id="product-variants"
      class="scroll-m-24 mt-8 md:mt-0"
      :default-open="!showFilter"
      :product="product"
      :grade-options="gradeOptions"
    />
  </article>
</template>
